/**
 * Errors that can be returned from the Service
 */
export var EventServiceErrorType;
(function (EventServiceErrorType) {
    EventServiceErrorType["invalidIdentifier"] = "invalidIdentifier";
    EventServiceErrorType["publisherIdAlreadyInUse"] = "publisherIdAlreadyInUse";
    EventServiceErrorType["unexpectedError"] = "unexpectedError";
    EventServiceErrorType["eventingFallbackNotAllowed"] = "eventingFallbackNotAllowed";
    EventServiceErrorType["persistentSubscribersNotSupported"] = "persistentSubscribersNotSupported";
    EventServiceErrorType["subscriberNotPersistent"] = "subscriberNotPersistent";
    EventServiceErrorType["subscriberIdNotSupported"] = "subscriberIdNotSupported";
    EventServiceErrorType["subscriptionHandlesNotSupported"] = "subscriptionHandlesNotSupported";
    EventServiceErrorType["isStartingPausedNotSupported"] = "isStartingPausedNotSupported";
})(EventServiceErrorType || (EventServiceErrorType = {}));
//# sourceMappingURL=eventservice.js.map